import { Stack, styled } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { getLLDate } from '@retail/utils';
import { SelectInputField } from '@shared/components';
import { isBefore } from 'date-fns';

interface Props {
  priceDates: Date[];
  selectedPriceDate?: string;
  selectPriceDate: (date: string) => void;
}

export function PriceDatePicker({ priceDates, selectedPriceDate, selectPriceDate }: Props) {
  const t = useMyAssortmentTFunction();

  const datesAsString = priceDates.map((date) => {
    const formattedDate = getLLDate(date) as string;
    const notFutureDate = isBefore(date, new Date());
    return {
      name: notFutureDate ? t('myAssortment.productCard.currentPrice') : formattedDate,
      value: formattedDate,
    };
  });

  return (
    <Stack px={2} alignSelf="flex-end">
      <StyledSelectInputField
        margin="none"
        size="small"
        disabled={priceDates.length < 2}
        value={selectedPriceDate}
        onChange={(e) => selectPriceDate(e.target.value as string)}
        name="name"
        menuItems={datesAsString}
      />
    </Stack>
  );
}

const StyledSelectInputField = styled(SelectInputField)(({ theme }) => ({
  borderRadius: Number(theme.shape.borderRadius) * 2,
  '.MuiOutlinedInput-notchedOutline': { borderBottom: 0 },
  padding: 0,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  borderBottom: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  fontSize: theme.typography.body1?.fontSize,
}));
